"use client";

import { ProblemSection } from "@/components/sections/problem";
import { problem } from "@/lib/data/services-trend-management";

export function Problem() {
  return (
    <ProblemSection
      eyebrow={problem.eyebrow}
      title={problem.title}
      lede={problem.lede}
      pillars={problem.pillars}
      accent={problem.accent}
    />
  );
}
